import {BasePqmFieldValue} from "./BasePqmFieldValue";
import {PqmFieldRegister} from "./PqmFieldRegister";
import {TicketsCL} from "../../generated/TicketsCL";
import {MuNamedWidgets} from "mu-widget/lib/MuWidget";
import {PqmProcData} from "../pqmTypes";
import {MultiUpload} from "../../MultiUpload";
import {AttachList} from "../../AttachList";

export class PqmFieldAttach extends BasePqmFieldValue {
	protected cl: TicketsCL = new TicketsCL();
	// @ts-ignore
	muNamedWidget: MuNamedWidgets<{
		attachNew: MultiUpload,
		attachList: AttachList,
	}>

	static getValueTypes(): string[] {
		return ["attach:*"];
	}

	beforeIndex() {
		// @ts-ignore
		this.muAppendContent(`
			<div mu="attachNew:MultiUpload"></div>
			<div mu="attachList:AttachList"></div>
		`);
	}

	isFilled(): boolean {
		return this.muNamedWidget.attachList.hasAnyAttach() || this.muNamedWidget.attachNew.getAllFiles().length > 0;
	}

	async afterIndex() {
		const data = this.getPropertyInAncestors('pqmProcData') as PqmProcData;
		if (data.procDataId) {
			await this.muNamedWidget.attachList.bindData({
				procDataId: data.procDataId,
				pqmPacketId: this.pqmPacketId,
			});
			this.onChange();
		}
	}

	attachNew_change() {
		this.onChange();
	}

	async afterSave(res: PqmProcData): Promise<any> {
		return await this.muNamedWidget.attachNew.sendToBackend((ctx, send) => {
			ctx.url = this.rawUploadUrl + "?metadata=" + encodeURIComponent(JSON.stringify({
				procDataId: res.procDataId,
				pqmPacketId: this.pqmPacketId,
				fileName: ctx.file.name,
				contentType: ctx.file.type,
				size: ctx.file.size,
			}));
			send();
		});
	}

	setDisabled(disabled: boolean) {
		this.muVisible(!disabled, 'attachNew');
	}
}

// @ts-ignore
PqmFieldRegister.register(PqmFieldAttach);